import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { CheckBoxTable, SortDataColumn } from "../../models/table.model";
import { Subscription, debounceTime } from "rxjs";
import { SortTableService } from "../../services/sort-table.service";
import { TableHeightService } from "../../services/table-height.service";
import { TableSwitch } from "../../components/switch-table/switch-table.component";
import { ModalService } from "../../services/modal.service";
import { NotificationService } from "../../services/notification.service";
import { PaymentViewDataService } from "./services/payment-view-data.service";
import { FilterModelDto } from "../../models/filter.model";
import { PaymentViewDto } from "./models/payment-view.models";
import { FormSelectModelDto } from "../payment-link-list/models/paylinks.model";
import { PaymentViewDetailUpdateService } from "./services/payment-view-detail-update.service";
import { FilterSettingService } from "src/app/services/filter-setting.service";
import { CheckboxTableService } from "src/app/services/checkbox-table.service";
import { PermissionService } from "src/app/services/permission.service";

@Component({
	selector: "app-payment-view-list",
	templateUrl: "./payment-view-list.component.html",
	styleUrls: ["./payment-view-list.component.scss"],
})
export class PaymentViewListComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild("tableBlock") tableBlock: ElementRef | undefined;
	@ViewChild("tableBody") tableBody: ElementRef | undefined;
	@ViewChild("contentBlock") contentBlock: ElementRef | undefined;

	delta = 150;
	lastPage = false;
	currentPage = 0;

	selectedRow: any[] = [];

	isOpenFilter = false;

	isOpenModalAddPaymentView = false;
	isOpenModalEditPaymentView = false;
	isOpenModalDeletePaymentView = false;

	filterAdditional: FilterModelDto[] | undefined;
	filterStatuses: FilterModelDto[] | undefined;
	filterBanks: FilterModelDto[] | undefined;

	moneyRemitterCodes: FormSelectModelDto[] | undefined;
	recipientBank: FormSelectModelDto[] | undefined;

	paymentViewList: PaymentViewDto[] = [];

	sortColumnData: SortDataColumn | undefined;

	subs: Subscription[] = [];

	paymentId: number | undefined;

	filterData: any;
	searchWord: string | undefined = "";

	constructor(
		private sortTableService: SortTableService,
		private tableHeightService: TableHeightService,
		private renderer: Renderer2,
		private modalService: ModalService,
		private notificationService: NotificationService,
		private paymentViewDataService: PaymentViewDataService,
		private checkboxTableService: CheckboxTableService,
		private filterSettingService: FilterSettingService,
		public permissionService: PermissionService
	) {}

	ngOnInit() {
		this.initFilter();
		this.initModal();
		// this.getPaymentViewList()
		this.initCheckboxSelectAll();
		this.loadSelectData();

		this.sortColumn("PAYMENT_TYPE_ID");
	}

	ngAfterViewInit() {
		this.subs.push(
			this.tableHeightService.tableHeight$.subscribe({
				next: (res) => {
					this.renderer.setStyle(this.tableBlock?.nativeElement, "height", res);
				},
			})
		);
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	initCheckboxSelectAll() {
		this.subs.push(
			this.checkboxTableService.checkboxSelectAll$.subscribe({
				next: (res) => {
					this.selectedRow = [];
					if (res) {
						this.paymentViewList.forEach((item) => this.selectedRow.push(item.id));
					}
				},
			})
		);
	}

	loadSelectData() {
		this.paymentViewDataService.loadPaymentViewSelect().subscribe({
			next: (res) => {
				this.moneyRemitterCodes = res["money_remitter_codes"];
				this.recipientBank = res["recipient_banks"];
			},
		});
	}

	initModal() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => {
					if (!res) {
						this.isOpenModalAddPaymentView = false;
						this.isOpenModalEditPaymentView = false;
						this.isOpenModalDeletePaymentView = false;
					}
				},
			})
		);
	}

	initFilter() {
		this.subs.push(
			this.paymentViewDataService.loadPaymentViewFilter().subscribe({
				next: (res) => {
					this.filterStatuses = res["statuses"];
					this.filterBanks = res["banks"];
					this.filterAdditional = res["additional_params"];
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterSetData$.subscribe({
				next: (res) => {
					this.filterData = res;
					this.currentPage = 0;

					this.paymentViewList = [];
					this.getPaymentViewList();
					this.selectedRow = [];
					this.checkboxTableService.compareCount$.next();
				},
			})
		);

		this.subs.push(
			this.filterSettingService.inputSearch$.pipe(debounceTime(300)).subscribe({
				next: (res) => {
					this.paymentViewDataService.loadSearchList(res).subscribe({
						next: (res) => {
							this.filterSettingService.responseSearchData$.next(res.content);
						},
					});
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterSearchWord$.subscribe({
				next: (res) => {
					this.searchWord = res;
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterAllReset$.subscribe({
				next: () => {
					this.searchWord = "";
					this.filterData = undefined;
					this.currentPage = 0;

					this.paymentViewList = [];
					this.getPaymentViewList();
					this.selectedRow = [];
					this.checkboxTableService.compareCount$.next();
				},
			})
		);
	}

	getPaymentViewList() {
		this.lastPage = true;
		this.paymentViewDataService.loadPaymentViewList(this.currentPage, this.searchWord, this.filterData).subscribe({
			next: (res) => {
				this.paymentViewList.push(...res.content);
				this.currentPage++;
				this.lastPage = res.last;
			},
		});
	}

	toggleFilter(filterState: boolean) {
		this.isOpenFilter = filterState;
	}

	onScroll(event: any): void {
		const tableBodyHeight = this.tableBody?.nativeElement.clientHeight;
		const tableBlockHeight = this.tableBlock?.nativeElement.clientHeight;
		const scrollTable = event.target.scrollTop;
		if (tableBodyHeight - tableBlockHeight - scrollTable < this.delta && !this.lastPage) {
			this.getPaymentViewList();
		}
	}

	sortColumn(column: string) {
		this.sortColumnData = this.sortTableService.sort(column);

		const sort = `order=${this.sortColumnData?.order}&field=${this.sortColumnData?.field}`;
		this.sortTableService.sortColum$.next(sort);

		this.currentPage = 0;
		this.paymentViewList = [];
		this.getPaymentViewList();
	}

	toggleActivateLink(item: TableSwitch) {
		if (this.permissionService.hasPermission(["PAYMENT_TYPE_BLOCK"])) {
			this.paymentViewDataService.changeStatusPaymentView(item.id, !item.state).subscribe({
				next: () => {
					this.notificationService.setConfiguration(
						item.state ? "icon-2" : "icon-1",
						"warning",
						`PAYMENT_VIEW_PAGE.NOTIFICATION.${item.state ? "UNLOCK_PAYMENT" : "BLOCK_PAYMENT"}`,
						"PAYMENT_VIEW_PAGE.NOTIFICATION.DESCRIPTION"
					);

					this.notificationService.showNotification();
				},
			});
		} else {
			this.notificationService.setConfiguration(
				"icon-1",
				"warning",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_ERROR",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_DESCRIPTION_1"
			);
			this.notificationService.showNotification();
		}
	}

	openModalDelete() {
		this.isOpenModalDeletePaymentView = true;
	}

	deleteGroup() {
		this.modalService.closeModal();
		this.subs.push(
			this.paymentViewDataService.deletePaymentViewGroup(this.selectedRow).subscribe({
				next: () => {
					this.modalService.closeModal();
					this.notificationService.setConfiguration(
						"icon-6",
						"error",
						"PAYMENT_VIEW_PAGE.NOTIFICATION.DELETE__TITLE",
						"PAYMENT_VIEW_PAGE.NOTIFICATION.DESCRIPTION"
					);
					this.notificationService.showNotification();

					// TODO Временно надо будет решить как без доб запроса обрновлять данные...
					this.paymentViewList = [];
					this.currentPage = 0;
					this.getPaymentViewList();
				},
			})
		);
	}

	openModalAdd() {
		this.isOpenModalAddPaymentView = true;
	}

	addSuccess() {
		this.modalService.closeModal();

		this.notificationService.setConfiguration(
			"icon-4",
			"success",
			"PAYMENT_VIEW_PAGE.NOTIFICATION.ADD__TITLE",
			"PAYMENT_VIEW_PAGE.NOTIFICATION.DESCRIPTION"
		);
		this.notificationService.showNotification();

		// TODO Временно надо будет решить как без доб запроса обрновлять данные...
		this.selectedRow = [];
		this.paymentViewList = [];
		this.currentPage = 0;
		this.getPaymentViewList();
	}

	editSuccess() {
		this.modalService.closeModal();
		this.notificationService.setConfiguration(
			"icon-2",
			"warning",
			"PAYMENT_VIEW_PAGE.NOTIFICATION.EDIT__TITLE",
			"PAYMENT_VIEW_PAGE.NOTIFICATION.DESCRIPTION"
		);
		this.notificationService.showNotification();

		this.selectedRow = [];
		this.currentPage = 0;
		this.paymentViewList = [];
		this.getPaymentViewList();
	}

	openEditModal(id: number) {
		this.paymentId = id;
		this.isOpenModalEditPaymentView = true;
	}

	checkChange(item: CheckBoxTable) {
		if (item.state) {
			this.setCheckboxState(item);
		} else {
			this.clearCheckboxState(item);
		}
		this.checkboxTableService.compareCount$.next();
	}

	setCheckboxState(item: CheckBoxTable) {
		this.selectedRow.push(item.id);
	}

	clearCheckboxState(item: CheckBoxTable) {
		for (let i = 0; i < this.selectedRow.length; i++) {
			if (item.id === this.selectedRow[i]) {
				this.selectedRow.splice(i, 1);
				return;
			}
		}
	}
}
